var TrilliumUrlHelpers = (function ($) {

    removeURLParameterAndUpdateUrlState = function (url, parameter) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            url = urlparts[0] + '?' + pars.join('&');
            return history.replaceState({}, '', url);
        } else {
            return url;
        }
    }

    return {
        removeURLParameterAndUpdateUrlState: function (url, parameter) {
            removeURLParameterAndUpdateUrlState(url, parameter);
        }
    };

})(window.jQuery);

window.TrilliumUrlHelpers = TrilliumUrlHelpers;
